<!--
 * @Author: your name
 * @Date: 2022-04-19 15:45:49
 * @LastEditTime: 2022-05-27 17:03:15
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/mall/index.vue
-->
<template>
  <div class="activeCenter">
    <div class="activeItem" v-for="(item, index) of bannerAct" :key="index">
      <p class="item_titles">{{ item.name }}</p>
      <img :src="item.material.banner" class="itemBanner" />

      <router-link class="footer_flex" :to="{
      path: 'Actives',
      query: {
        type: 'banner',
        url: item.material && item.material.banner,
        id: item.id,
        shopIDs: item.shops,
        sharePicUrl: item.sharePicUrl && item.sharePicUrl,
        shareTitle: item.shareTitle && item.shareTitle,
        shareText: item.shareText && item.shareText,
        code: code,
        appcode: appcode,
        shareAble: item.shareAble,
        distributeType: item.distributeType
      }
    }">
        <div class="footer_main">
          {{ item.description }}
        </div>
        <div class="footer_btn">详情 ></div>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "activeCenter",
  data() {
    return {
      bannerAct: []
    };
  },
  mounted() {
    this.RequestVIP(
      "h5/campaign/all",
      r => {
        if (r.data.code == "20000") {
          const { data } = r.data;
          this.bannerAct =
            data.length &&
            data.filter(item => item.material && item.material.banner !== "");
        }
      },
      err => console.log(err)
    );
  },
  methods: {}
};
</script>
<style scoped>
.activeCenter {
  font-size: 8px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
  padding: 0 7px 0;
  box-sizing: border-box;
  background: rgba(245, 245, 245, 0.39);
}

.activeItem {
  position: relative;
  width: 100%;
  height: 151px;
  border-radius: 6px;
  margin-top: 10px;
}

.itemBanner {
  width: 100%;
  height: 118px;
}

.item_titles {
  width: 100%;
  position: absolute;
  top: 93px;
  left: 0;
  height: 25px;
  line-height: 25px;
  box-sizing: border-box;
  font-size: 11px;
  color: #ffffff;
  padding-left: 10px;
  font-weight: 500;
  background: rgba(0, 0, 0, 0.39);
}

.footer_flex {
  width: 100%;
  height: 33px;
  display: flex;
  justify-content: space-between;
  padding: 0 11px;
  box-sizing: border-box;
  background: #ffffff;
  text-decoration: none;
}

.footer_main {
  width: 70%;
  height: 100%;
  overflow: hidden;
  /* text-overflow: ellipsis;
  white-space: nowrap; */
  font-size: 8px;
  color: #212121;
  line-height: 2;
}

.footer_btn {
  width: 20%;
  line-height: 33px;
  font-size: 8px;
  color: #757575;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/activeCenter/index.vue